import React, { useContext, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Report, ReportInstance } from 'models/report/report';
import { AccountType } from 'globals/types';

type ReportContextInterface = {
  report: ReportInstance;
};

export const ReportContext = React.createContext<ReportContextInterface>({
  report: Report.create(),
});

interface ReportContextProviderProps {
  userId: string | null;
  accountTypes: AccountType[];
}

const ReportContextProvider: React.FC<ReportContextProviderProps> = ({
  children,
  userId,
  accountTypes,
}) => {
  const [types] = useState<AccountType[]>(accountTypes);
  const [report, setReport] = useState<ReportInstance>();

  useEffect(() => {
    const activeAccountType = types.length ? types[0] : AccountType.PERSONAL;
    const newReport = Report.create({
      userId,
      accountTypes: types,
      activeAccountType,
    });
    setReport(newReport);
  }, [types, userId]);

  if (!report) return null;

  return (
    <ReportContext.Provider value={{ report }}>
      {children}
    </ReportContext.Provider>
  );
};

export const useReportContext = (): ReportContextInterface => {
  const reportContext = useContext(ReportContext);

  if (reportContext === null) {
    throw new Error(
      'reportContext must be used within the ReportContextProvider!'
    );
  }

  return {
    ...reportContext,
  };
};

export default observer(ReportContextProvider);
